export function JSONStringify<T, U>(
    obj: T,
    replacer?: (this: unknown, key: string, value: unknown) => U,
    space?: string | number | null
) {
    const rv = JSON.stringify(obj, replacer, space);

    if (rv === undefined) {
        throw new Error("JSON.stringify returned undefined");
    }

    return rv;
}

export function getElementById(id: string): HTMLElement {
    const rv = document.getElementById(id);

    if (rv === null) {
        throw new Error(`Element ID ${id} not found`);
    }

    return rv;
}
